import { render, staticRenderFns } from "./AddNewOrderViewModal.vue?vue&type=template&id=d74b3002&"
import script from "./AddNewOrderViewModal.vue?vue&type=script&lang=js&"
export * from "./AddNewOrderViewModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOrderViewModal.vue?vue&type=style&index=0&id=d74b3002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports